import { render, staticRenderFns } from "./GenericPopups.vue?vue&type=template&id=f3c52722&"
import script from "./GenericPopups.vue?vue&type=script&lang=js&"
export * from "./GenericPopups.vue?vue&type=script&lang=js&"
import style0 from "./GenericPopups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports